import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./login.scss";


const Login = () => {
  const [password, setPassword] = useState("");
  const [isTouched, setIsTouched] = useState(false);
  const [isError, setIsError] = useState(false);
  const history = useHistory();

  useEffect(() => {
    if (localStorage.getItem("authPassword") === "trump2025") {
      history.replace("/");
    }
  }, [history]);

  const handleInputChange = (e) => {
    const value = e.target.value;
    setPassword(value);


    if (value === "") {
      setIsError(false);
    }
  };

  const handleContinue = () => {
    if (password === "trump2025") {
      localStorage.setItem("authPassword", password);
      window.location.href = "/";
    } else {
      setIsError(true);
    }
  };

  return (
    <>
      <div className="mainlogindiv">
        <section className="loginmain">
          <video className='main-banner-video'
            muted="muted" playsinline="playsinline"
            autoPlay
            loop
            width="100%"
            id="myVideo">
            <source src="\assets\bannervideo.mp4" type="video/mp4" />
          </video>
          <span className="bannershade"></span>

          <div className="mainlogo">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="77"
              height="45"
              viewBox="0 0 77 45"
              fill="none"
            >
              <path
                d="M0.960991 39.88V20.2829C0.960991 17.2156 3.24902 16.3006 4.39303 16.2266H6.33785C14.7395 13.9595 17.0621 7.28039 17.1733 4.22425C17.2177 0.756917 19.3404 -0.035825 20.3961 0.00122063H28.2865C30.2425 0.0456735 31.213 1.87196 31.4538 2.77954V10.0032C31.5427 14.0039 28.1198 14.4485 26.3973 14.1706C18.4402 15.5931 15.5618 22.1722 15.1173 25.2839V41.8982C15.1173 43.5127 13.3022 44.4972 12.3946 44.7876H4.78201C1.49248 44.7876 0.864028 41.5159 0.960991 39.88Z"
                fill="#ECECEC"
              />
              <path
                d="M31.4647 39.88V20.2829C31.4647 17.2156 33.7527 16.3006 34.8967 16.2266H36.8416C45.2432 13.9595 47.5658 7.28039 47.677 4.22425C47.7214 0.756917 49.8441 -0.035825 50.8998 0.00122063H58.7902C60.7462 0.0456735 61.7167 1.87196 61.9575 2.77954V10.0032C62.0464 14.0039 58.6235 14.4485 56.901 14.1706C48.9439 15.5931 46.0655 22.1722 45.621 25.2839V41.8982C45.621 43.5127 43.8059 44.4972 42.8983 44.7876H35.2857C31.9962 44.7876 31.3677 41.5159 31.4647 39.88Z"
                fill="#ECECEC"
              />
              <path
                d="M61.9592 19.789C61.9592 17.6262 63.7126 15.8728 65.8755 15.8728H72.8561C75.019 15.8728 76.7724 17.6262 76.7724 19.789V40.8714C76.7724 43.0343 75.019 44.7876 72.8561 44.7876H65.8755C63.7126 44.7876 61.9592 43.0343 61.9592 40.8714V19.789Z"
                fill="#ECECEC"
              />
            </svg>
            <h1 className="logohead">MRKTS</h1>
          </div>

          <div className="innerlogin">
            <h1 className="loginhead">Enter password to continue</h1>

            <div className="inputmain">
              <h6 className="inputpara">Password</h6>
              <input
                placeholder="Enter password here..."
                type="password"
                value={password}
                onChange={handleInputChange}
                onFocus={() => setIsTouched(true)}
                onBlur={() => setIsTouched(false)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleContinue();
                  }
                }}
                className={`innerinput 
    ${isTouched ? "activeborder" : ""} 
    ${isError ? "errorborder" : ""}
  `}
              />

              {isError && <p className="errorpara">Invalid Password</p>}
            </div>

            <div className="bottombtn">
              <button
                className={`continuebtn ${password === "" ? "disabledbtn" : ""
                  }`}
                onClick={handleContinue}
                disabled={password === ""}
              >
                Continue
              </button>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Login;
